import React from 'react';
import { Empty, Icon, Button } from 'antd';

const FetchError = ({ onClick, msg }) => {
  return (
    <Empty
      image={<Icon type="close-circle" />}
      imageStyle={{
        height: 60,
        fontSize: 60,
        color: 'red',
      }}
      description={
        <>
          {msg && (
            <>
              <span>{msg}</span>
              <br />
            </>
          )}
          <span>Если это не первая попытка, обратитесь в поддержку</span>
        </>
      }
    >
      <Button
        type="primary"
        onClick={onClick}
      >
        Попробовать снова
      </Button>
    </Empty>
  );
};

export default FetchError;
